const accountEN = {

	comingSoon: "Coming soon",

	menu: {
		bookings: "Appointments",
		favorites: "Favourites",
		reviews: "Reviews",
		notifications: "Notifications",
		language: "Language",
		security: "Login And Security",
		privacy: "Privacy Policy",
		terms: "Terms of Service",
		refund: "Refund Policy",
		contact: "Contact",
		helpandsupport: "Help & Support",
		reportsandperfomance: "Reports & Performance",
		marketing: "Marketing",
		category: "Categories",
		referral: "Referral",
		billing: "Billing",
		logout: "Log Out",
	},


	header: {
		title: "Account",
		back: "Back",
	},

	emptyState: {
		title: "Your Account",
		description: "Select an option from the menu to view your appointments, favourites or settings.",
	},
	
	language: {
        title: "Language",
        current: "Current language",
    },

	bookings: {
		title: "Appointments",
		subtitleUpcoming: (count) => `${count} upcoming`,
		noUpcoming: "No upcoming appointments",
		noHistory: "No past visits yet",
		historyTitle: "History",
		cancel: "Cancel",
		reschedule: "Reschedule",
		confirmed: "confirmed",
		cancelled: "cancelled",
		addToCalendar: "Add to Calendar",
		emailSent: "Email sent",
	},

	favorites: {
		title: "Favourites",
		empty: "You haven’t added any favourites yet.",
	},

	reviews: {
		title: "My Reviews",
		empty: "You haven’t written any reviews yet.",
		rating: "Rating",
	},

	settings: {
		title: "Account & Settings",
		comingSoon: "Settings will be available soon.",
	},

	status: {
		confirmed: "Confirmed",
		cancelled: "Cancelled",
		pending: "Pending",
	},

	categories: {
		title: "Business Category",
		category: "Category",
		subCategory: "Sub-category",
		select: "Select",
		save: "Save",
		saving: "Saving…",
	},

	notifications: {
        title: "Notifications",
    
        sections: {
            bookings: "Bookings",
            reviews: "Reviews",
            reminders: "Reminders",
            shop: "Shop",
        },
    
        items: {
            bookings: "New bookings",
            reschedule: "Rescheduled bookings",
            cancellation: "Cancelled bookings",
            reminder24h: "24 hours before booking",
            reminder1h: "1 hour before booking",
            reviews: "New reviews",
            shopBookings: "New bookings for my staff",
            shopUpdates: "Shop updates & announcements",
        },
    
        push: "Push Notifications",
        pushEnabled: "Push notifications are enabled on this device.",
        pushCtaTitle: "Enable push notifications",
        pushCtaHint: "Get real-time alerts on your phone.",
    },
	referral: {
        title: "Referral Program",

        hero: {
            title: "Save $15 per referral",
            subtitle: "Invite other businesses to Sin Fila. Each active referral gives you $15 off your next bill.",
            earned: (amount) => `You’ve saved $${amount} so far`,
        },

        code: {
            label: "Your referral code",
            copy: "Copy code",
        },

        link: {
            label: "Share your link",
            copy: "Copy link",
        },

        hint: "Discounts are applied automatically once the referred shop activates billing.",

        history: {
            title: "Referral history",
            empty: "No referrals yet",
            pending: "Pending",
            active: "Active",
        },
    },

	contact: {
		title: "Contact Support",
		email: "Email",
		phone: "Phone (optional)",
		subject: "Subject",
		messagePlaceholder: "Your message...",
		send: "Send message",
		sending: "Sending...",
		success: "Message sent successfully",
		errorRequired: "Message is required",
		errorFailed: "Failed to send message",
	},
	
	security: {
		title: "Login And Security",
	
		emailTitle: "Email",
		passwordTitle: "Reset Password",
	
		comingSoon: "Security settings will be available soon.",
	},

	forgotPassword: {
		subtitle: "We’ll send you an email with instructions to reset your password.",
	
		send: "Send reset link",
		sending: "Sending...",
	
		success: "Password reset email sent successfully.",
	
		toast: {
			error: "Failed to send reset email. Please try again."
		}
	},
};

export default accountEN;
